import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { Svg } from '../../../../base';
const TriggerCustomFC = ({ isOpen, isArrow, trigger }) => {
    return isArrow ? (_jsxs(Flex, { gap: '6px', alignItems: 'center', cursor: 'pointer', _hover: { cursor: 'pointer' }, children: [_jsx(Box, { children: trigger }), _jsx(Box, { transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform var(--tr-200-ei)', children: _jsx(Svg, { name: 'ArrowDown', size: 's20' }) })] })) : (_jsx(_Fragment, { children: trigger }));
};
export const TriggerCustom = memo(TriggerCustomFC);
//# sourceMappingURL=TriggerCustom.js.map